import {api} from '../../api';
import {createMutation} from '../../lib';

const {deleteContractsCidDocumentsDocumentId} = api.contracts;

export const useDeleteContractsCidDocumentId = createMutation(
  (params: Parameters<typeof deleteContractsCidDocumentsDocumentId>) =>
    deleteContractsCidDocumentsDocumentId(...params),
);
